<div class="container-fluid">
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <h3 class="m-0 font-weight-bold" style="color: #1A355E;">KULLANICILAR</h3>
        <ol class="breadcrumb ">
            <li class="breadcrumb-item active">Ayarlar</li>
            <li class="breadcrumb-item active">Kullanıcılar</li>
        </ol>
    </div>
    <div class="data-grid">
        <p-table #dt [value]="users$ | async" [paginator]="true" [rows]="25" [showCurrentPageReport]="true"
            styleClass="p-datatable-sm" [rowHover]="true"
            currentPageReportTemplate="{totalRecords} veriden {first} - {last} gösteriliyor.."
            [globalFilterFields]="['fullName','userName','password','roleName']" [responsive]="true"
            [rowsPerPageOptions]="[5,10,25,50]">
            <ng-template pTemplate="caption">
                <button pButton type="button" class="p-button-info" label="Yeni" (click)="showAddModal()"></button>
                <div style="text-align: right">
                    <input style="float:right" type="text" pInputText size="50" placeholder="Ara"
                        (input)="applyFilterGlobal($event, 'contains')" style="width:auto">
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="fullName" [width]="'25%'">Ad Soyad<p-sortIcon field="fullName"></p-sortIcon>
                    </th>
                    <th pSortableColumn="userName" [width]="'25%'">Kullanıcı Adı<p-sortIcon field="userName">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="password" [width]="'20%'">Şifre<p-sortIcon field="password">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="roleName" [width]="'20%'">Rol<p-sortIcon field="roleName">
                        </p-sortIcon>
                    </th>
                    <th [width]="'10%'">

                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-users>
                <tr>
                    <td>{{users.fullName}}</td>
                    <td>{{users.userName}}</td>
                    <td>{{users.password}}</td>
                    <td>{{users.roleName}}</td>
                    <td>
                        <button pButton pRipple type="button" icon="pi pi-pencil"
                            class="p-button-rounded p-button-success" pTooltip="Güncelle" tooltipPosition="bottom"
                            (click)="showUpdateModal(users.id)"></button>
                        <button pButton pRipple type="button" icon="pi pi-trash"
                            class="p-button-rounded p-button-danger" pTooltip="Sil" tooltipPosition="bottom"
                            (click)="showDeleteModal(users.id)"></button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>


<p-dialog header="KULLANICI EKLE" [(visible)]="addModal" [modal]="true" [style]="{width: '50vw'}" [baseZIndex]="10000"
    [draggable]="false" [resizable]="false">
    <form [formGroup]="form">
        <div class="form-group">
            <p-dropdown [options]="roles" [style]="{'width': '100%'}" optionLabel="name" optionValue="value"
                formControlName="roleId">
            </p-dropdown>
        </div>
        <div class="form-group">
            <input class="form-control" formControlName="fullName" placeholder="Ad Soyad" autofocus>
        </div>
        <div class="form-group">
            <input class="form-control" formControlName="userName" placeholder="Kullanıcı Adı">
        </div>
        <div class="form-group">
            <input type="text" class="form-control" formControlName="password" placeholder="Şifre">
        </div>

    </form>
    <ng-template pTemplate="footer">
        <p-button (click)="addModal=false" label="Vazgeç" styleClass="p-button-danger"></p-button>
        <p-button (click)="save('Add')" label="Kaydet" styleClass="p-button-success" [disabled]="form.invalid">
        </p-button>
    </ng-template>
</p-dialog>

<p-dialog header="KULLANICI GÜNCELLE" [(visible)]="updateModal" [modal]="true" [style]="{width: '50vw'}"
    [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <form [formGroup]="form">
        <div class="form-group">
            <p-dropdown [options]="roles" [style]="{'width': '100%'}" optionLabel="name" optionValue="value"
                formControlName="roleId">
            </p-dropdown>
        </div>
        <div class="form-group">
            <input class="form-control" formControlName="fullName" placeholder="Ad Soyad" autofocus>
        </div>
        <div class="form-group">
            <input class="form-control" formControlName="userName" placeholder="Kullanıcı Adı">
        </div>
        <div class="form-group">
            <input type="text" class="form-control" formControlName="password" placeholder="Şifre">
        </div>

    </form>

    <ng-template pTemplate="footer">
        <p-button (click)="updateModal=false" label="Vazgeç" styleClass="p-button-danger"></p-button>
        <p-button (click)="save('Update')" label="Kaydet" styleClass="p-button-success" [disabled]="form.invalid">
        </p-button>
    </ng-template>
</p-dialog>

<p-dialog header="KULLANICI SİL" [(visible)]="deleteModal" [modal]="true" [style]="{width: '50vw'}" [baseZIndex]="10000"
    [draggable]="false" [resizable]="false">
    <p class="p-m-0">Kullanıcı silinecek. Onaylıyor musunuz?</p>
    <ng-template pTemplate="footer">
        <p-button (click)="deleteModal=false" label="Vazgeç" styleClass="p-button-dark"></p-button>
        <p-button (click)="deleteUser()" label="Sil" styleClass="p-button-danger"></p-button>
    </ng-template>
</p-dialog>